import { InvalidOperationException } from "../exceptions/exceptions";

export class StoreUpToDateService {
  static isUpToDate(existingId: string | undefined, newId: string) {
    // A url with a specific id has been requested, while we have no id in our store
    // RESULT: We load the data from the backend
    if (existingId === undefined) {
      return false;
    }

    // A url with a specific id has been requested but we have already loaded data with the same id
    // RESULT: We do not need to load the same data again.
    if (existingId === newId) {
      return true;
    }

    // A url with a specific id has been requested and the requested id is different than the one we already have in our store
    // RESULT: We load the data from the backend (with the new id)
    if (existingId !== newId) {
      return false;
    }

    throw new InvalidOperationException(
      "It seems like we have forgotten to cover a possible case when deciding if the store is up to date or not - this needs to be investigated",
    );
  }
}
